import api from '../../../../libs/api';
import { useMutation } from 'react-query';
import React from 'react';
const deleteFolderConfiguration = (folderId: any) =>
    api.delete('/api/v2/AsiteRelaticsSync/DeleteRelaticsConfigurationFolder', {
        safe: true,
        params: folderId,
    });

const useDeleteConfigurationFolder = () => {

    const [visibleDeleteDialog, setVisibleDeleteDialog] = React.useState(false);
    const deleteFolderConfigurationMutation = useMutation(
        (folderId: any) => {
            return deleteFolderConfiguration(folderId);
        }
    );

    return { deleteFolderConfigurationMutation, visibleDeleteDialog, setVisibleDeleteDialog };

};

export default useDeleteConfigurationFolder;